$borderRadius: 4px;
$inputHeight: 32px;
$buttonHeight: 32px;
$buttonWidth: 32px;

:host {
  display: block;
  max-width: 100%;
}

.input-container {
  width: 90px;
}

.increment-box > * {
  width: 28px;
  height: 20px;
  margin: calc(var(--spacer) / 2 - 2px) calc(var(--spacer) - 4px);
  padding: calc(var(--spacer) / 2);
  font-size: var(--body-size-small);

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
}

.number-control,
.increment-box > * {
  border: none;
  border-radius: $borderRadius;
  cursor: pointer;
  color: var(--body-text-arrows-400);
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--chart-050-hover);
}

.number-control {
  width: $buttonWidth;
  height: $buttonHeight;
  font-size: var(--body-size-small);

  &:first-of-type {
    margin-right: calc(var(--spacer) - 4px);
  }

  &:last-of-type {
    margin-left: calc(var(--spacer) - 4px);
  }
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.input {
  color: var(--body-text-arrows-400);
  font-size: var(--body-size);
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  border-radius: $borderRadius;
  border: 1px solid var(--chart-100-pressed);
  height: $inputHeight;
  padding-right: 2px;
  background-color: var(--white-layout-301-level-0-elevation);
  font-family: var(--font-family-secondary);

  &--field {
    display: block;
    padding: var(--input-padding);
    flex: 1;
    outline: none;
    border: none;
    box-shadow: none;
    color: var(--input-field-color, var(--body-text-arrows-400));
    background-color: transparent;
    cursor: text;
    user-select: text;
    font-size: var(--body-size);
    font-family: var(--font-family-secondary);
    width: 100%;
  }

  &--field[readonly] {
    cursor: pointer;
    &::selection {
      color: unset;
      background: none;
    }
  }

  &:hover {
    border-color: var(--main-titles-inputs-600);
  }

  &:focus-within {
    border-color: var(--blue-layout-301-active);
  }

  &:active {
    border-color: var(--blue-layout-301-active);
  }
}
